// extracted by mini-css-extract-plugin
module.exports = {"questionPanel":"QuestionPanel_questionPanel__2hv9a","questionPanelText":"QuestionPanel_questionPanelText__3TzAh"};